import type { IconSvgObject } from './types';

const CircleOffIcon: IconSvgObject = [
  ["path", { d: "M7.88376 2.88376C9.13912 2.31604 10.5327 2 12 2C17.5228 2 22 6.47715 22 12C22 13.4673 21.684 14.8609 21.1162 16.1162M4.92893 4.92893C3.11929 6.73858 2 9.23858 2 12C2 17.5228 6.47715 22 12 22C14.7614 22 17.2614 20.8807 19.0711 19.0711", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleOffIcon;
